import React, { useState, useEffect, useRef } from "react";
import { Box, Fab } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

import { useStore } from '../Store'

import useOnlineStatus from '../hooks/useOnlineStatus'
import Header from "./Header";
import YearFilter from "./YearFilter"
import ObservationList from "./ObservationList"
import BottomNavigationCustom from './BottomNavigationCustom'

import { useConfirm } from './ConfirmDialog'
import { useToaster } from "./Toaster";
import ObservationService from "../services/ObservationService";
import moment from "moment";


const Observations = ({ history }) => {
  const isOnline = useOnlineStatus()
  const { confirm } = useConfirm()
  const { showError, showMessage } = useToaster()
  const { year, createObservation, deleteUnsaved, unsaved } = useStore()

  const showErrorRef = useRef(showError)

  const [observations, setObservations] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {

    const fetchData = async () => {
      try {
        setLoading(true)
        setObservations([])
        const response = await ObservationService.getObservations(year)
        setObservations(response.data.sort((a, b) => a.timeStart > b.timeStart ? -1 : 1))
        setLoading(false)
      }
      catch (error) {
        showErrorRef.current(error)
        setLoading(false)
      }
    }
    if (!isOnline) {
      setObservations([])
    } else {
      fetchData()
    }

  }, [year, isOnline, unsaved, showErrorRef])


  const handleAdd = () => {
    const now = moment()
    const newObs = { ...createObservation(), description: now.format('DD-MM-YYYY'), timeStart: now.format('YYYY-MM-DDTHH:mm:00') }
    history.push({ pathname: '/observation', state: { observation: newObs } })
  }

  const handleSelect = (obs) => {
    if (obs.offline) {
      history.push({ pathname: '/observation', state: { observation: obs } })
    } else {
      if (isOnline) {
        ObservationService.getObservation(obs.id)
          .then((response) => {
            history.push({ pathname: '/observation', state: { observation: response.data } })
          })
          .catch((error) => {
            if (error.response && error.response.status === 401) history.push('/login')
            showError(error)
          })
      } else {
        showError("Waarneming kan niet gewijzigd worden in offline modus")
      }
    }
  }

  const handleDelete = async (obs) => {
    const canDelete = await confirm(`Wilt u de waarneming ${obs.description} verwijderen?`)
    if (canDelete) {
      if (obs.id > 0) {
        if (isOnline) {
          ObservationService.deleteObservation(obs)
            .then((response) => {
              showMessage("waarneming verwijderd")
              setObservations(observations.filter(item => item.id !== obs.id))
            })
            .catch((error) => {
              if (error.response && error.response.status === 401) history.push('/login')
              showError(error)
            })
        } else {
          showError("Waarneming kan niet verwijderd worden in offline modus")
        }
      } else {
        deleteUnsaved(obs)
        setObservations(observations.filter(item => item.id !== obs.id))
      }

    }
  }

  return (
    <>
      <Header title="Losse waarnemingen" />
      <Box m={2}>
        <YearFilter />
        <ObservationList 
          loading={loading} 
          onSelect={handleSelect} 
          onDelete={handleDelete} 
          observations={[...unsaved.filter(item=>!('observations' in item)), ...observations.filter(v1 => !unsaved.some(v2 => v2.id === v1.id)).sort((a, b) => (a.timeStart < b.timeStart ? 1 : -1))]} 
        />
        <Fab color="secondary" aria-label="add" onClick={handleAdd}>
          <AddIcon />
        </Fab>
      </Box>
      <BottomNavigationCustom />
    </>
  )

}


export default Observations